import React, { useState, useRef, useEffect } from 'react';
import { FiChevronDown } from 'react-icons/fi';

const VotingViewModeDropdown = ({ viewMode, onChange, isAuthenticated, isSemiAdmin = false, isTabStyle = false, fullWidth = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // 點擊外部關閉
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [isOpen]);

  const options = [
    { value: 'all', label: '投票廣場' },
    { value: 'myPosts', label: '我的投票文' },
    { value: 'strategy', label: '投票攻略' },
    ...(isSemiAdmin ? [{ value: 'reported', label: '被檢舉貼文' }] : [])
  ];

  const selectedOption = options.find(opt => opt.value === viewMode) || options[0];

  const handleSelect = (optionValue) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  // Tab樣式：集成到tab區域
  if (isTabStyle) {
    // 如果未登入，只顯示"投票廣場"
    if (!isAuthenticated) {
      return (
        <button
          className="px-4 py-3 text-base font-bold transition-all whitespace-nowrap text-purple-600 border-b-4 border-purple-600 -mb-0.5"
        >
          投票廣場
        </button>
      );
    }

    return (
      <div className={`relative ${fullWidth ? 'w-full' : 'inline-block'}`} ref={dropdownRef}>
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className={`px-4 py-3 text-base font-bold transition-all whitespace-nowrap flex items-center gap-1 ${fullWidth ? 'w-full justify-center text-center' : ''} ${
            isOpen
              ? 'text-purple-600 border-b-4 border-purple-600 -mb-0.5'
              : 'text-purple-600 border-b-4 border-purple-600 -mb-0.5'
          }`}
        >
          <span>{selectedOption.label}</span>
          <FiChevronDown
            className={`w-4 h-4 transition-transform ${
              isOpen ? 'transform rotate-180' : ''
            }`}
          />
        </button>

        {isOpen && (
          <div className="absolute left-0 top-full mt-1 w-40 bg-white border-2 border-purple-200 rounded-lg shadow-xl z-50 overflow-hidden">
            {options.map((option) => (
              <button
                key={option.value}
                type="button"
                onClick={() => handleSelect(option.value)}
                className={`w-full px-4 py-3 text-left transition-colors text-sm ${
                  viewMode === option.value
                    ? 'bg-purple-50 text-purple-900 font-medium'
                    : 'text-gray-900 hover:bg-purple-50'
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }

  // 原始樣式：獨立的下拉選擇器
  // 如果未登入，不顯示下拉選擇器
  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={`px-4 py-2 text-sm font-medium rounded-lg transition-all flex items-center gap-2 ${
          isOpen
            ? 'bg-purple-100 text-purple-700 border-2 border-purple-400'
            : 'bg-white text-gray-700 border-2 border-gray-200 hover:border-purple-300 hover:text-purple-600'
        }`}
      >
        <span>{selectedOption.label}</span>
        <FiChevronDown
          className={`w-4 h-4 transition-transform ${
            isOpen ? 'transform rotate-180' : ''
          }`}
        />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white border-2 border-purple-200 rounded-lg shadow-xl z-50 overflow-hidden">
          {options.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => handleSelect(option.value)}
              className={`w-full px-4 py-3 text-left transition-colors ${
                viewMode === option.value
                  ? 'bg-purple-50 text-purple-900 font-medium'
                  : 'text-gray-900 hover:bg-purple-50'
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default VotingViewModeDropdown;

